"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var home_html_1 = __importDefault(require("./home.html"));
var store_1 = __importDefault(require("../store"));
function config($stateProvider, $compileProvider, $urlRouterProvider, $httpProvider, $locationProvider, ENV, HTML_FIVE_MODE, $ngVueProvider) {
    $ngVueProvider.setRootVueInstanceProps({
        store: store_1.default,
    });
    $httpProvider.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
    //$httpProvider.defaults.headers.post["Content-Type"] = 'application/x-www-form-urlencoded';
    $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|file|sms|tel|mailto):/);
    $httpProvider.interceptors.push([
        "$injector",
        function ($injector) {
            return $injector.get("AuthInterceptor");
        },
    ]);
    if (ENV !== "local" || HTML_FIVE_MODE === "on") {
        $locationProvider.html5Mode(true);
    }
    $urlRouterProvider.when("", "/login");
    $urlRouterProvider.when("/", "/login");
    $stateProvider.state("drivecoach", {
        url: "",
        abstract: true,
        template: home_html_1.default,
        controller: "MainController",
        controllerAs: "vm",
    });
}
config.$inject = [
    "$stateProvider",
    "$compileProvider",
    "$urlRouterProvider",
    "$httpProvider",
    "$locationProvider",
    "ENV",
    "HTML_FIVE_MODE",
    "$ngVueProvider",
];
exports.default = config;
